export const environment = {
  name: 'prod',
  production: true,
  endpoint: 'https://localhost:7239/',
  timeStamp: '12/11/2024 04:57:13 PM CET',
  googleAnalyticsId: 'UA-000000000-0'
};


